import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import BranchMixin, { BranchMixinDefaultValues, branchFromJSON } from 'automation-ui-action-features/records/BranchMixin';
const ABTestBranchDefaultValues = Object.assign({}, BranchMixinDefaultValues, {
  branchName: undefined
});
/**
 * An ABTestBranch represents a single branch of an AB Test Branch action
 *
 */
class ABTestBranch extends BranchMixin(createImmutableObjectClass(ABTestBranchDefaultValues, {
  fromJSON: json => Object.assign({}, json, branchFromJSON(json)),
  toJSON: branch => branch
})) {
  getBranchName() {
    return this.branchName || '';
  }
  setBranchName(branchName) {
    return this.set('branchName', branchName);
  }
}
export default ABTestBranch;